export default "__VITE_ASSET__30dca79d__"